import { render, staticRenderFns } from "./custom-bill-new.vue?vue&type=template&id=a41b34c6&"
import script from "./custom-bill-new.vue?vue&type=script&lang=js&"
export * from "./custom-bill-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports